import React from 'react';
import MainPage from './components/MainPage';

const App = () => {
  return (
    <div
      style={{
        background: '#3174c1',
        height: '100vh',
      }}
    >
      <MainPage />
    </div>
  );
};

export default App;
